// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "nl.greenhood.wallet",
    name: "Greenhood",
    homepage: "https://www.greenhood.nl",
    image_id: "7b6aaa4d-fa17-4cc6-71e1-79f2e68c0900",
    app: {
        browser: null,
        ios: "https://apps.apple.com/us/app/greenhood-wallet/id1661248135",
        android: "https://play.google.com/store/apps/details?id=com.greehood.wallet",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: "nl.greenhood.wallet",
    mobile: {
        native: "greenhood://",
        universal: null,
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map